(() => {
  const init = () => {
    let scheduled = false;
    let pendingSort = false;
    let pendingPagination = false;
    let paginationHook;
    let expire;
    const isMobileProductList = () =>
      /\/(?:search|collections\/[^/]+)\/?$/.test(window.location.pathname) && window.innerWidth <= 740;
    const scrollToPaginationResults = () => {
      const count = document.querySelector('.c_boost-sd__product-count');
      if (!count) return;
      const header = document.querySelector('store-header');
      const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
      const top = Math.max(0, count.getBoundingClientRect().top + window.scrollY - headerBottom - 24);
      // Finish downwards so the header stays compact instead of covering the count.
      window.scrollTo({ top: Math.max(0, top - 48), behavior: 'instant' });
      requestAnimationFrame(() => {
        requestAnimationFrame(() => window.scrollTo({ top, behavior: 'instant' }));
      });
    };
    const installPaginationHook = () => {
      const integration = window.boostWidgetIntegration;
      const customization = integration?.app?.[integration.env]?.customization;
      if (!customization || typeof integration.regisCustomization !== 'function') return;
      const previous = customization.afterPagination;
      if (paginationHook && previous === paginationHook) return;
      paginationHook = function afterPagination(...args) {
        const result = typeof previous === 'function' ? previous.apply(this, args) : undefined;
        if (pendingPagination) {
          pendingPagination = false;
          // Cancel Boost's earlier smooth scroll and align the visible results.
          requestAnimationFrame(scrollToPaginationResults);
        }
        return result;
      };
      // Boost resolves callbacks by name; Shopify minifies named expressions.
      Object.defineProperty(paginationHook, 'name', { value: 'afterPagination' });
      integration.regisCustomization(paginationHook);
    };
    const reorder = () => {
      scheduled = false;
      document.querySelectorAll('.boost-sd__sorting-list').forEach((list) => {
        const popular = list.querySelector('[data-value="best-selling"]');
        const newest = list.querySelector('[data-value="created-descending"]');
        if (popular && newest && newest.previousElementSibling !== popular) popular.after(newest);
      });
    };
    const observer = new MutationObserver((records) => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(reorder); }
      if (pendingSort && records.some((record) => {
        const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return element?.closest('.boost-sd__product-list, .boost-sd__product-item');
      })) {
        pendingSort = false;
        clearTimeout(expire);
        requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'instant' }));
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', (event) => {
      const sorting = event.target.closest('.boost-sd__sorting-option');
      const pagination = isMobileProductList() &&
        event.target.closest('.boost-sd__pagination-button, .boost-sd__pagination-number');
      if (!sorting && !pagination) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (pagination && (pagination.disabled || pagination.getAttribute('aria-disabled') === 'true' ||
          pagination.getAttribute('aria-current') === 'page' ||
          pagination.classList.contains('boost-sd__pagination-number--active'))) return;
      if (pagination) {
        pendingPagination = true;
        installPaginationHook();
        return;
      }
      pendingSort = true;
      clearTimeout(expire);
      expire = setTimeout(() => { pendingSort = false; }, 4000);
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, true);
    // Dispatch one click on touch release; iOS hover/focus must not consume the first tap.
    let paginationTouch;
    const touchPagination = (target) => isMobileProductList() &&
      target.closest('.boost-sd__pagination-button, .boost-sd__pagination-number');
    document.addEventListener('touchstart', (event) => {
      paginationTouch = null;
      if (event.touches.length !== 1) return;
      const button = touchPagination(event.target);
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true' ||
          button.getAttribute('aria-current') === 'page' ||
          button.classList.contains('boost-sd__pagination-number--active') ||
          button.classList.contains('boost-sd__pagination-number--disabled')) return;
      const touch = event.touches[0];
      paginationTouch = { button, id: touch.identifier, x: touch.clientX, y: touch.clientY };
    }, { capture: true, passive: true });
    document.addEventListener('touchmove', (event) => {
      if (!paginationTouch) return;
      const touch = Array.from(event.touches).find((item) => item.identifier === paginationTouch.id);
      if (event.touches.length !== 1 || !touch ||
          Math.abs(touch.clientX - paginationTouch.x) > 10 ||
          Math.abs(touch.clientY - paginationTouch.y) > 10) paginationTouch = null;
    }, { capture: true, passive: true });
    document.addEventListener('touchcancel', () => { paginationTouch = null; }, { passive: true });
    document.addEventListener('touchend', (event) => {
      const tap = paginationTouch;
      paginationTouch = null;
      if (!tap || !event.cancelable || event.touches.length ||
          touchPagination(event.target) !== tap.button ||
          !Array.from(event.changedTouches).some((touch) => touch.identifier === tap.id &&
            Math.abs(touch.clientX - tap.x) <= 10 && Math.abs(touch.clientY - tap.y) <= 10)) return;
      event.preventDefault(); // Suppress the subsequent synthetic mouse click.
      tap.button.click(); // Reuse Boost's normal pagination and our afterPagination hook.
    }, { capture: true, passive: false });
    reorder();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* TABIO-1255: clearing the results query also refreshes the product list. */
(() => {
  // Run before Boost's document handlers, including the mobile search overlay.
  window.addEventListener('click', (event) => {
    const clear = event.target.closest('[data-group="clear-search-form"], .boost-sd__button-text-x--clear, .boost-sd__search-form-close-btn, .boost-sd__button-text-x--clear-input-search-form, .boost-sd__search-form button[type="reset"]');
    if (!clear) return;

    const url = new URL(window.location.href);
    if (!/\/search\/?$/.test(url.pathname)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    document.querySelectorAll('.boost-sd__search-form-input, input[name="q"]').forEach((input) => {
      input.value = '';
      input.blur();
    });
    // Keep selected filters and sorting; pagination belongs to the old query.
    url.searchParams.delete('q');
    url.searchParams.delete('page');
    url.hash = '';
    window.location.assign(url.pathname + url.search);
  }, true);
})();

/* TABIO-1255: restore visible filter chips after Boost replaces its result DOM. */
(() => {
  const init = () => {
    let scheduled = false;
    const sync = () => {
      scheduled = false;
      let target = document.querySelector('.boost-sd__selected-filter-values');
      if (!target) {
        const toolbar = document.querySelector('.boost-sd__search-result-toolbar-container');
        if (!toolbar) return;
        target = document.createElement('div');
        target.className = 'boost-sd__selected-filter-values';
        toolbar.after(target);
      }
      const source = document.querySelector('.boost-sd__refine-by-vertical-refine-by > .boost-sd__refine-by-vertical-refine-by-list');
      const filters = Array.from(source?.querySelectorAll('button[metadata]') || []).flatMap((button) => {
        try {
          const filter = JSON.parse(button.getAttribute('metadata')).action?.clearFilter;
          if (!filter?.key) return [];
          return [{ key: filter.key, value: filter.value, label: button.textContent.replace(/\s+/g, ' ').trim() }];
        } catch (_) { return []; }
      });
      const signature = JSON.stringify(filters);
      if (target.dataset.cFilterSignature === signature && target.querySelectorAll('.c_search-selected-filter').length === filters.length) return;
      const fragment = document.createDocumentFragment();
      filters.forEach((filter) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'c_search-selected-filter';
        button.dataset.filterKey = filter.key;
        button.dataset.filterValue = JSON.stringify(filter.value);
        button.setAttribute('aria-label', `${filter.label}を解除`);
        const label = document.createElement('span');
        label.textContent = filter.label;
        const close = document.createElement('span');
        close.textContent = '×';
        close.setAttribute('aria-hidden', 'true');
        button.append(label, close);
        fragment.appendChild(button);
      });
      target.replaceChildren(fragment);
      target.dataset.cFilterSignature = signature;
    };
    const observer = new MutationObserver(() => {
      if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener('click', (event) => {
      const button = event.target.closest('.c_search-selected-filter');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = new URL(window.location.href);
      const key = button.dataset.filterKey;
      const value = JSON.parse(button.dataset.filterValue);
      const values = url.searchParams.getAll(key);
      url.searchParams.delete(key);
      if (values.length > 1) values.filter((item) => item !== String(value)).forEach((item) => url.searchParams.append(key, item));
      url.searchParams.delete('page');
      window.location.assign(url.pathname + url.search + url.hash);
    }, true);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* Keep price controls operable across Boost's desktop/mobile filter redraws. */
(() => {
  const selector = '.boost-sd__filter-option-range-slider--container[id^="pf_p_"]';
  const number = value => Number(String(value).replace(/,/g, '').trim());
  let drag = null;
  let navigating = false;
  const context = target => {
    const group = target.closest(selector);
    if (!group) return null;
    const handles = [...group.querySelectorAll('.noUi-handle')];
    const inputs = [...group.querySelectorAll('input[data-type]')];
    const base = group.querySelector('.noUi-base');
    if (handles.length !== 2 || inputs.length !== 2 || !base) return null;
    return { group, handles, inputs, base,
      min: number(handles[0].getAttribute('aria-valuemin')),
      max: number(handles[1].getAttribute('aria-valuemax')),
      values: handles.map(handle => number(handle.getAttribute('aria-valuenow'))) };
  };
  const paint = ctx => {
    const span = ctx.max - ctx.min;
    if (!(span > 0)) return;
    const percent = ctx.values.map(value => 100 * (value - ctx.min) / span);
    ctx.handles.forEach((handle, index) => {
      handle.parentElement.style.transform = `translate(${percent[index] - 100}%, 0px)`;
      handle.setAttribute('aria-valuenow', String(ctx.values[index]));
      handle.setAttribute('aria-valuetext', ctx.values[index].toLocaleString('ja-JP'));
      ctx.inputs[index].value = String(ctx.values[index]);
    });
    const connect = ctx.base.querySelector('.noUi-connect');
    if (connect) connect.style.transform = `translate(${percent[0]}%, 0px) scale(${(percent[1] - percent[0]) / 100}, 1)`;
  };
  const syncSelectedRange = () => {
    if (drag || navigating) return;
    const url = new URL(window.location.href);
    document.querySelectorAll(selector).forEach(group => {
      const ctx = context(group);
      const raw = url.searchParams.get(group.id);
      if (!ctx || !raw) return;
      const values = raw.split(':').map(number);
      if (values.length !== 2 || !values.every(Number.isFinite)) return;
      ctx.values = [Math.max(ctx.min, values[0]), Math.min(ctx.max, values[1])];
      if (ctx.values[0] <= ctx.values[1]) paint(ctx);
    });
  };
  const init = () => {
    let scheduled = false;
    syncSelectedRange();
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; syncSelectedRange(); });
    }).observe(document.body, {childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  const commit = ctx => {
    if (navigating || !ctx.values.every(Number.isFinite)) return;
    const url = new URL(window.location.href);
    url.searchParams.set(ctx.group.id, ctx.values.join(':'));
    url.searchParams.delete('page');
    navigating = true;
    window.location.assign(url.href);
  };
  const applyInput = input => {
    const ctx = context(input);
    if (!ctx) return;
    const index = input.dataset.type === 'min' ? 0 : 1;
    const previous = number(ctx.handles[index].getAttribute('aria-valuenow'));
    let value = input.value.trim() === '' ? (index === 0 ? ctx.min : ctx.max) : number(input.value);
    if (!Number.isFinite(value)) value = previous;
    ctx.values[index] = Math.round(Math.max(index === 0 ? ctx.min : ctx.values[0],
      Math.min(index === 0 ? ctx.values[1] : ctx.max, value)));
    paint(ctx);
    if (ctx.values[index] !== previous) commit(ctx);
  };
  document.addEventListener('pointerdown', event => {
    const handle = event.target.closest?.('.noUi-handle');
    if (!handle || (event.button !== 0 && event.pointerType === 'mouse')) return;
    const ctx = context(handle);
    if (!ctx || !(ctx.max > ctx.min)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const index = ctx.handles.indexOf(handle);
    drag = {ctx, index, pointerId:event.pointerId, initial:ctx.values[index]};
    handle.setPointerCapture(event.pointerId);
  }, true);
  document.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.pointerId) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const {ctx,index} = drag;
    const rect = ctx.base.getBoundingClientRect();
    if (!rect.width) return;
    let fraction = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
    if (document.documentElement.dir === 'rtl') fraction = 1 - fraction;
    const value = Math.round(ctx.min + fraction * (ctx.max - ctx.min));
    ctx.values[index] = index === 0 ? Math.min(value, ctx.values[1]) : Math.max(value, ctx.values[0]);
    paint(ctx);
  }, {capture:true,passive:false});
  document.addEventListener('pointerup', event => {
    if (!drag || event.pointerId !== drag.pointerId) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const {ctx,index,initial} = drag;
    drag = null;
    if (ctx.values[index] !== initial) commit(ctx);
  }, true);
  document.addEventListener('pointercancel', () => {
    if (drag) { drag.ctx.values[drag.index] = drag.initial; paint(drag.ctx); }
    drag = null;
  }, true);
  ['mousedown', 'touchstart'].forEach(type => document.addEventListener(type, event => {
    if (event.target.closest?.('.noUi-handle') && context(event.target)) event.stopImmediatePropagation();
  }, {capture:true,passive:true}));
  document.addEventListener('keydown', event => {
    const ctx = context(event.target);
    if (!ctx) return;
    if (event.target.matches('input[data-type]') && event.key === 'Enter') {
      event.preventDefault(); event.stopImmediatePropagation(); applyInput(event.target);
    } else if (event.target.matches('.noUi-handle') && ['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
      event.preventDefault(); event.stopImmediatePropagation();
      const index = ctx.handles.indexOf(event.target);
      const direction = document.documentElement.dir === 'rtl' ? -1 : 1;
      let value = ctx.values[index] + (event.key === 'ArrowRight' ? direction : -direction);
      if (event.key === 'Home') value = index === 0 ? ctx.min : ctx.values[0];
      if (event.key === 'End') value = index === 0 ? ctx.values[1] : ctx.max;
      ctx.values[index] = Math.max(index === 0 ? ctx.min : ctx.values[0], Math.min(index === 0 ? ctx.values[1] : ctx.max, value));
      paint(ctx); commit(ctx);
    }
  }, true);
  document.addEventListener('blur', event => {
    if (!event.target.matches?.(`${selector} input[data-type]`)) return;
    event.stopImmediatePropagation(); applyInput(event.target);
  }, true);
})();
